import PropTypes from "prop-types";
import { Alert, Button, Grid } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";

BarraSeleccionSubtareas.propTypes = {
  cantidad: PropTypes.number.isRequired,
  onEliminar: PropTypes.func.isRequired,
};

/**
 * Barra de acciones sobre las subtareas seleccionadas. Compartida por `Subtareas.js` y
 * `SubTareasDialog.js` para que ambas vistas se vean y se comporten igual.
 */
export default function BarraSeleccionSubtareas({ cantidad, onEliminar }) {
  if (cantidad < 1) return null;

  return (
    <Grid container>
      <Grid item xs={10} md={10}>
        <Alert>
          {cantidad}{" "}
          {cantidad === 1 ? "subtarea seleccionada" : "subtareas seleccionadas"}
        </Alert>
      </Grid>
      <Grid item xs={2} md={2}>
        <Button variant="contained" fullWidth onClick={onEliminar}>
          <DeleteIcon />
        </Button>
      </Grid>
    </Grid>
  );
}
